import React from "react";
import CheckDefecto from "../../../../../Common/Components/CheckDefecto";
import RadioButtonDefecto from "../../../../../Common/Components/RadioButtonDefecto2";

const TipoCuenta = ({ AdministradoraId, data, selectCheckBox, selectRadio, getGruposafinidad }) => {
    const { ERROR_PRODUCT, GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA} = data;
    const tipoProductoEmp = (data.TipoProductoEmpInd == "E");
    const tipoProductoInd = (data.TipoProductoEmpInd == "I");

    return (
        <div className="row top-separator-xs">
            <div className="col-xs-12">
                <label className="label-primary">{"Tipo de Cuenta"}</label>
                <RadioButtonDefecto
                    nombre={"TIPOCUENTA"}
                    descripcion={"Empresa"}
                    valor={"E"}
                    checked={tipoProductoEmp}
                    referencia={"TIPOCUENTA-E"}
                    selectRadio={(valor) => selectRadio("TipoProductoEmpInd", valor)} >
                    <div className="left-separator-xs">
                        {GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA.filter(item => item.EmpresaIndividuos == "E").map(item => {
                            const referencia = `GACTBAE-${item.Id}`;

                            return (
                                <RadioButtonDefecto
                                    key={item.Id}
                                    nombre={"GACTBAE"}
                                    descripcion={item.Descripcion}
                                    valor={item.Id}
                                    checked={item.Checked}
                                    referencia={referencia}
                                    disabled={tipoProductoInd}
                                    selectRadio={(valor) =>{ 
                                        selectRadio("GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA", valor, AdministradoraId); 
                                        getGruposafinidad(valor);}} />
                            );
                        })}
                    </div>
                </RadioButtonDefecto>

                <RadioButtonDefecto
                    nombre={"TIPOCUENTA"}
                    descripcion={"Individuos"}
                    valor={"I"}
                    checked={tipoProductoInd}
                    referencia={"TIPOCUENTA-I"}
                    selectRadio={(valor) => selectRadio("TipoProductoEmpInd", valor)}>
                    <div className="left-separator-xs">
                        {GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA.filter(item => item.EmpresaIndividuos == "I").map(item => {
                            const referencia = `GACTBAI-${item.Id}`;

                            return (
                                <RadioButtonDefecto
                                    key={item.Id}
                                    nombre={"GACTBAI"}
                                    descripcion={item.Descripcion}
                                    valor={item.Id}
                                    checked={item.Checked}
                                    referencia={referencia}
                                    disabled={tipoProductoEmp}
                                    selectRadio={(valor) =>{ 
                                        selectRadio("GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA", valor, AdministradoraId); 
                                        getGruposafinidad(valor);}} />
                            );
                        })}
                    </div>

                    <div className="col-xs-12">
                        <label className="label-primary">{"Subproducto - Agrupamiento"}</label>
                        <CheckDefecto
                            nombre={"NA - Nuevos Atributos"}
                            check={data.NuevosAtributos}
                            referencia={"SUBPROAGRUP"}
                            selectCheckBox={(event) => {
                                if (tipoProductoInd) {
                                    selectCheckBox("NuevosAtributos", event.target.checked);
                                }
                            }}
                        />
                        {/*se pide que sea el primero NA - Nuevos Atributos, validar si efectivamente siempre es as�*/}
                        {/*GET_AGRUPAMIENTO.filter(item => item.Id == 1).map((item) => {
                            const descripcion = `${item.Codigo} - ${item.Descripcion}`;
                            const referencia = `GANA-${item.Id}`;

                            return (
                                <CheckDefecto
                                    key={item.Id}
                                    nombre={descripcion}
                                    check={item.Checked}
                                    activo={item.Activo}
                                    referencia={referencia}
                                    selectCheckBox={() => {
                                        if (tipoProductoInd) {
                                            selectCheckBox("GET_AGRUPAMIENTO", item.Id);
                                        }
                                    }}
                                />
                            )
                        })*/}
                    </div>
                </RadioButtonDefecto>

                {ERROR_PRODUCT["seleccionoTipoEmpresa"] == false
                    && <label className="error">{"Debe seleccionar al menos un tipo de cuenta."}</label>}
            </div>
        </div>
    );
}

export default TipoCuenta;